<div class="moving" [ngClass]="{'sub-layer-active': store.state.common.determinantSection.topLayer === 'edit'}">
    <layer-header (closeLayer)="closeLayer()"
                  (setListView)="setListView($event)"
                  [listToggle]="listToggle"
                  [listIcons]=false
                  [title]="'Form Determinant'">
    </layer-header>
    <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
                      class="row layer sub-layer px-3 pt-1"
                      [serviceId]="serviceId"
                      [determinant]="store.state.common.determinantSection.determinant"
                      (formSubmit)="closeEdit()"
                      (editCancel)="closeEdit()"></determinant-new>
    <div class="row {{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}}">
        <div class="col-12">
            <div class="row">
                <determinant-builder-new [serviceId]="serviceId"
                                         [jsonString]="getJsonString()"
                                         [determinantMapById]="determinantMapById"
                                         (onSave)="updateForm()"
                                         (onCancel)="closeLayer()"
                                         (onChange)="change($event)"
                                         class="col-12">
                </determinant-builder-new>
            </div>
        </div>
    </div>
  </div>
